import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import React from 'react';
import { CustomerKind } from '@bringg/types';
import Tooltip from '../../components/tooltip/tooltip';

export interface Translations {
	contact: string;
	verificationCode: string;
	customerKindCustomer: string;
	customerKindStore: string;
	customerKindWarehouse: string;
	customerKindDistributionHub: string;
	customerKindBusiness: string;
	customerKindLocker: string;
}

interface CustomerContactProps {
	name?: string;
	kind?: CustomerKind;
	phone?: string;
	email?: string;
	verificationCode?: string;
	translations: Translations;
}

const getIconAndToolTipForCustomerKind = (
	kind: CustomerKind,
	translations: Translations
): { icon: BringgFontIcons; tooltipTitle: string } => {
	if (kind == null) return;

	switch (kind) {
		case CustomerKind.CUSTOMER:
			return { icon: BringgFontIcons.Customer, tooltipTitle: translations.customerKindCustomer };
		case CustomerKind.STORE:
			return { icon: BringgFontIcons.Store, tooltipTitle: translations.customerKindStore };
		case CustomerKind.WAREHOUSE:
			return { icon: BringgFontIcons.Warehouse, tooltipTitle: translations.customerKindWarehouse };
		case CustomerKind.DISTRIBUTION_HUB:
			return { icon: BringgFontIcons.DistributionHub, tooltipTitle: translations.customerKindDistributionHub };
		case CustomerKind.BUSINESS:
			return { icon: BringgFontIcons.Business, tooltipTitle: translations.customerKindBusiness };
		case CustomerKind.LOCKER:
			return { icon: BringgFontIcons.Locker, tooltipTitle: translations.customerKindLocker };
		default:
			return { icon: BringgFontIcons.Customer, tooltipTitle: translations.customerKindCustomer };
	}
};

const CustomerContact: React.FC<CustomerContactProps> = ({
	name,
	kind,
	phone,
	email,
	verificationCode,
	translations
}: CustomerContactProps) => {
	const customerKind = getIconAndToolTipForCustomerKind(kind, translations);
	return (
		<div className="customer-contact-container">
			<div className="customer-title">{translations.contact}</div>
			<div className="customer-details">
				<div className="customer-name">
					{customerKind && (
						<Tooltip title={customerKind.tooltipTitle}>
							<BringgIcon iconName={customerKind.icon} className="customer-kind" />
						</Tooltip>
					)}
					<span>{name}</span>
				</div>

				<div className="customer-phone">
					<BringgIcon iconName={BringgFontIcons.Phone} />
					<span>{phone}</span>
				</div>
				{email ? (
					<div className="customer-email">
						<BringgIcon iconName={BringgFontIcons.MessageMail} />
						<span>{email}</span>
					</div>
				) : null}
				{verificationCode ? (
					<div className="verification-code">
						<BringgIcon iconName={BringgFontIcons.VerificationCode} />
						<span>
							{translations.verificationCode}:&#160;<span className="pin-code">{verificationCode}</span>
						</span>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default CustomerContact;
